const getDefaultDietaries = () => {
  return {
    vegan: false,
    vegetarian: false,
    glutenFree: false,
  };
};

const getDefaultSuitable = () => {
  return {
    adults: undefined,
    children: undefined,
  };
};

const getDefaultItem = () => {
  return {
    status: 'active',
    suitables: [getDefaultSuitable()],
    dietaries: getDefaultDietaries(),
  };
};

const getDefaultPerson = () => {
  return {
    id: '',
    adults: '',
    children: '',
  };
};

const getItemObjFromAPI = itemFromAPI => {
  let i = getDefaultItem();
  i.name = itemFromAPI.name;
  i.price = itemFromAPI.price;
  i.suitables = itemFromAPI.suitables;
  i.dietaries = itemFromAPI.dietaries;
  i.note = itemFromAPI.note;
  i.id = itemFromAPI.id;
  return i;
};

const getItemTypes = () => {
  return [
    { name: 'Collectable - Consumable', value: 'collectable-consumable' },
    { name: 'Cuisine - Drink', value: 'cuisine-drink' },
    { name: 'Cuisine - Food', value: 'cuisine-food' },
    { name: 'Accomodation - Night', value: 'accomodation-night' },
    { name: 'Location - Picnic Stop', value: 'location-picnic-stop' },
    { name: 'Location - Photo Stop', value: 'location-photo-stop' },
    { name: 'Location - Activity Stop', value: 'location-activity-stop' },
    { name: 'Taster Item', value: 'taster-item' },
  ];
};

export {
  getDefaultDietaries,
  getDefaultSuitable,
  getDefaultItem,
  getItemObjFromAPI,
  getDefaultPerson,
  getItemTypes,
};
